export default "__VITE_ASSET__CBz_C2u4__"